import { ActivityTypeBaseTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { ActivityTypeBaseType } from '@/services/graphql/types';

export const mapperToActivityTypeBaseTypeDataEnum = createEnumMapperFunction(
  ActivityTypeBaseType,
  ActivityTypeBaseTypeDataEnum
);
